import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-cream" data-id="element-153" data-mp="9luzmm7107tq">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-sage-light via-cream to-cream -z-10" data-id="element-154" data-mp="4mi47d239sfj" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-155" data-mp="127eereur1rdz">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-156" data-mp="xaxejma9zmkj">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/50 bg-gold/10 text-forest font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-157" data-mp="nbexpepnwgwp">
            🏓 Pickleball Instructor Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-ink" data-id="element-158" data-mp="3j8iyd2s0imwa">
            Solve a Full Year of Pickleball Lessons in Just{' '}
            <span className="text-gold-gradient" data-id="element-159" data-mp="3o59chkk9b8f2">5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-160" data-mp="39cpa4m4xl4yo">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-161" data-mp="35aat87ktofa1" />
          <img src="https://cdn.magicpatterns.com/uploads/cWPpsg5RfyWD3FsXuyE4Lj/Diseno_sin_titulo_(58).png" alt="Pickleball Instructor Ready — complete 6-volume teaching system with 150 ready-to-teach lessons and 5 bonuses" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-162" data-mp="2qkwmz8cjmdyv" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-163" data-mp="s21hi9lxc9yx">
          <p className="text-sm sm:text-lg md:text-xl text-charcoal leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-164" data-mp="n9i35afexat2">
            Pickleball Instructor Ready — 150 Ready-to-Teach Pickleball Lessons, 6 Volumes
            and 5 Strategic Bonuses. With drills, progressions, coaching cues, and complete
            corrections — all structured and ready to use starting today.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-165" data-mp="15zq17e499b2e">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-166" data-mp="111omf5dv3xwq">
              🟡 GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-charcoal" data-id="element-167" data-mp="3hqk9uf1wzmrs">
            <div className="flex items-center gap-1.5" data-id="element-168" data-mp="1xavymn782e8u">
              <CheckCircle size={14} className="text-forest" data-id="element-169" data-mp="21amtp33s7gj6" />
              <span data-id="element-170" data-mp="218toztcqb6dt">Premium 6-in-1 Teaching System</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-171" data-mp="2697noksfx3z6">
              <CheckCircle size={14} className="text-forest" data-id="element-172" data-mp="2b0fxhhxomrcv" />
              <span data-id="element-173" data-mp="2b20tzd3k4kdd">5 Strategic Bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-174" data-mp="2fyr6jqg5kxu1">
              <CheckCircle size={14} className="text-forest" data-id="element-175" data-mp="2kyvnfhkz3uks" />
              <span data-id="element-176" data-mp="2kxc7xt755nk2">Immediate Access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}